const COMPARE_PRODUCTS_LOCAL_STORAGE_KEY = "compare";
export {
  COMPARE_PRODUCTS_LOCAL_STORAGE_KEY
};
